import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export default function OContactBanner({ type, href }) {
	return (
		<Link href={href} to={href}>
			<section className={`o-section-contact-banner ${type}`}>
				<p className="title--light">
					<FormattedMessage id="CONTACT_BANNER.TITLE" defaultMessage="" />
				</p>
				<p className="sub-title">
					<FormattedMessage id="CONTACT_BANNER.SUB_TITLE" defaultMessage="" />
				</p>
			</section>
		</Link>
	);
}

OContactBanner.propTypes = {
	type: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.contact-banner.js